import { IsNotEmpty, IsUUID } from 'class-validator';

export class DeletePolicyVersionDto {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsUUID()
  @IsNotEmpty()
  versionId: string;
}
